import type { AppState } from '../types/domain'

export class ApiError extends Error {
  constructor(message: string, public readonly code = 'UNKNOWN_ERROR', public readonly status = 0) {
    super(message)
    this.name = 'ApiError'
  }
}

async function parse<T>(response:Response):Promise<T>{
  let data: {error?:string;message?:string;code?:string} = {}
  try { data=await response.json() } catch { /* preserve a stable error for HTML/proxy failures */ }
  if(!response.ok)throw new ApiError(data.error||data.message||'服务暂时不可用',data.code||'HTTP_ERROR',response.status)
  return data as T
}

/** Shared transport used by migrated and compatibility views. */
export function requestJson<T = unknown>(url: string, body?: unknown): Promise<T> {
  return fetch(url, {
    method: body === undefined ? 'GET' : 'POST',
    headers: body === undefined ? {} : {'Content-Type': 'application/json'},
    body: body === undefined ? undefined : JSON.stringify(body),
    cache: 'no-store',
  }).then(parse<T>)
}

export const api={
  state(params:URLSearchParams=new URLSearchParams()){return fetch(`/api/state${params.size?`?${params}`:''}`,{cache:'no-store'}).then(parse<AppState>)},
  action<T>(body:Record<string,unknown>,share?:string){return fetch(`/api/action${share?`?share=${encodeURIComponent(share)}`:''}`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).then(parse<{ok:true;result:T}>)},
  upload(file:File,params:URLSearchParams,onProgress?:(percent:number)=>void){return new Promise<Record<string,unknown>>((resolve,reject)=>{const xhr=new XMLHttpRequest();xhr.open('POST',`/api/upload?${params}`);xhr.setRequestHeader('X-File-Name',encodeURIComponent(file.name));xhr.upload.onprogress=e=>e.lengthComputable&&onProgress?.(Math.round(e.loaded/e.total*100));xhr.onerror=()=>reject(new Error('上传中断，请检查网络后重试'));xhr.onload=()=>{try{const value=JSON.parse(xhr.responseText);if(xhr.status>=400)throw new Error(value.error||'上传失败');resolve(value)}catch(error){reject(error)}};xhr.send(file)})},
  downloadUrl(id:string,share?:string){return `/api/download?id=${encodeURIComponent(id)}${share?`&share=${encodeURIComponent(share)}`:''}`},
}
